import { ScatterplotLayer } from '@deck.gl/layers';
import customFragmentShader from './customShader/dashedCircleLayer.glsl';

export default class DashedCircleLayer extends ScatterplotLayer {
  draw({ uniforms }) {
    super.draw({ uniforms });
  }

  getShaders() {
    return { ...super.getShaders(), fs: customFragmentShader };
  }
}

DashedCircleLayer.layerName = 'DashedCircleLayer';

DashedCircleLayer.defaultProps = {};
